import {DropdownCustom} from './DropdownCustom';
import {Collapsible} from './Collapsible';

const desktopRes = 1200;
const header = document.querySelector('.header');
const headerMenuBtn = document.querySelector('.header__menu-button');
const pageContent = document.querySelector('.page-content');
const paymentPopup = document.getElementById('payment-popup');
const cancelSubPopup = document.getElementById('cancel-sub-popup');

document.addEventListener('DOMContentLoaded', () => {
    const dropdown = new DropdownCustom({});
    new Collapsible();

    //handler for close-popup button

    const button = document.getElementById('payment-popup-close');
    if (button) {
        button.addEventListener('click', () => {
            paymentPopup.classList.toggle('payment-popup--active');
            document.body.classList.toggle('popup');
        });
    }

    const openCancelSubPopup = document.getElementById('open_cancel-sub_popup');
    if (openCancelSubPopup) {
        openCancelSubPopup.addEventListener('click', () => {
            cancelSubPopup.classList.toggle('opened');
        });
    }

    const closeCancelSubPopup = document.getElementById('cancel-sub-popup-close');
    if (closeCancelSubPopup) {
        closeCancelSubPopup.addEventListener('click', () => {
            cancelSubPopup.classList.toggle('opened');
        });
    }

    const buttonOpen = document.querySelectorAll('.pricing .pricing-item');
    if (buttonOpen) {
        buttonOpen.forEach((item) => {
            item.addEventListener('click', () => {
                paymentPopup.classList.toggle('payment-popup--active');
                document.body.classList.toggle('popup');
            });
        });
    }

    const profileEditNameInput = document.querySelectorAll('.text-editable__input');
    if (profileEditNameInput) {
        profileEditNameInput.forEach((item) => {
            item.addEventListener('click', () => {
                item.parentElement.classList.add('focus');
            });
            item.addEventListener('blur', () => {
                item.parentElement.classList.remove('focus');
            });
        });
    }

    // Mobile menu
    if (headerMenuBtn) {
        headerMenuBtn.addEventListener('click', () => {
            headerMenuBtn.classList.toggle('menu-button--active');
            document.body.classList.toggle('mobile-menu-active');
        });
    }

    // Header white
    if (header) {
        window.addEventListener('load', headerWhite);
        window.addEventListener('scroll', headerWhite);
    }

    // Password visibility
    const passwordFields = document.querySelectorAll('[data-password-input]');
    if (passwordFields) {
        passwordFields.forEach((field) => {
            const toggle = field.parentNode.querySelector('[data-password-toggle]');
            toggle.addEventListener('click', () => {
                if (field.getAttribute('type') === 'password') {
                    field.setAttribute('type', 'text');
                    toggle.classList.add('visible');
                } else {
                    field.setAttribute('type', 'password');
                    toggle.classList.remove('visible');
                }
            });
        });
    }

    // Sliders
    const templatesSlider = new Swiper('.templates-slider', {
        slidesPerView: 'auto',
        loop: true,
        centeredSlides: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
    const testimonialsSlider = new Swiper('.testimonials-slider', {
        slidesPerView: 'auto',
        autoHeight: true,
        loop: true,
        spaceBetween: 30,
        centeredSlides: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    // Rating
    try {
        $('[data-rating]').each(function () {
            const number = $(this).data('rating-number');
            $(this).rateYo({
                rating: number,
                halfStar: true,
                readOnly: true,
                ratedFill: '#FFBA49',
                starWidth: '12px',
                spacing: '4.5px',
                starSvg: `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M6 9.95016L2.87713 11.5436C2.50946 11.7313 2.08567 11.4177 2.1575 11.0113L2.75 7.65836L0.254009 5.29695C-0.0502481 5.00909 0.113068 4.49713 0.527809 4.43864L3.99139 3.95016L5.55431 0.876499C5.73965 0.512004 6.26035 0.512003 6.44569 0.876499L8.00861 3.95016L11.4722 4.43864C11.8869 4.49713 12.0502 5.00909 11.746 5.29695L9.25 7.65836L9.8425 11.0113C9.91433 11.4177 9.49054 11.7313 9.12287 11.5436L6 9.95016Z"/>
                </svg>`,
            });
            $(this).parent().find('.rating__number span').html(number);
        });
    } catch {
        console.log('jQuery is not loaded');
    }

    // Materialize
    // const dropdownTriggers = document.querySelectorAll('.dropdown-trigger')
    // const dropdownInstances = M.Dropdown.init(dropdownTriggers, {
    //   coverTrigger: false,
    //   alignment: 'right',
    //   onOpenStart: (el) => {
    //     el.closest('[data-dropdown]').classList.add('active')
    //   },
    //   onCloseStart: (el) => {
    //     el.closest('[data-dropdown]').classList.remove('active')
    //   }
    // })

    // Input mask
    try {
        Inputmask().mask(document.querySelectorAll('input'));
    } catch (e) {
        console.log('Inputmask is not loaded');
    }

    // Sticky sidebar
    try {
        const stickyInit = () => {
            const isDesk = window.screen.width > 991;
            const stickyEl = new Sticksy('[data-sticky]', {});

            if (isDesk) {
                stickyEl.onStateChanged = function (state) {
                    if (state === 'fixed') {
                        stickyEl.nodeRef.style.marginTop = getComputedStyle(header).height;
                    } else {
                        stickyEl.nodeRef.style.marginTop = '0';
                    }
                };
            } else {
                stickyEl.disable();
            }
        };
        stickyInit();
    } catch (e) {
        console.log('Sticksy plugin is not loaded');
    }

    //add progress bar to article
    const articleItem = jQuery('.article__inner');
    if (articleItem !== undefined && articleItem.length > 0) {
        const header = jQuery('header');
        header.append('<div class="article-progress"></div>');

        const articleProgressItem = jQuery('.article-progress');
        const articlePosition = articleItem.offset().top;
        const articleHeight = articleItem.height();

        //init progress bar if page was refreshed
        setArticleProgress(articlePosition, articleProgressItem, articleHeight);
        jQuery(document).scroll(function () {
            setArticleProgress(articlePosition, articleProgressItem, articleHeight);
        });
    }
    function setArticleProgress(articlePosition, articleProgressItem, articleHeight) {
        let bodyScroll = jQuery(document).scrollTop();
        let currentRelativePosition = bodyScroll - articlePosition;

        if (currentRelativePosition < 0) {
            articleProgressItem.css('width', '0%');
        } else if (currentRelativePosition > articleHeight) {
            articleProgressItem.css('width', '100%');
        } else {
            let width = (currentRelativePosition * 100) / articleHeight;
            articleProgressItem.css('width', width + '%');
        }
    }

    //add anchor smooth scroll on click
    jQuery(document).on('click', '#anchor-list a[href^="#"]', function (event) {
        event.preventDefault();
        jQuery('html, body').animate(
            {
                scrollTop: jQuery(jQuery.attr(this, 'href')).offset().top - 111,
            },
            500
        );
    });

    //add anchor active state to article sidebar
    jQuery(document).scroll(function () {
        var st = jQuery(this).scrollTop();
        jQuery('.all-templates-article__content > *[id]').each(function () {
            var id = jQuery(this).attr('id');
            if (st > jQuery(this).offset().top - 130) {
                if (jQuery('.categories__item a[href="#' + id + '"]').length > 0) {
                    jQuery('.categories__item a').removeClass('active');
                    jQuery('.categories__item a[href="#' + id + '"]').addClass('active');
                }
            } else {
                jQuery(this).parents('.categories__item').prev().find('a').addClass('active');
            }
        });
    });
});

window.addEventListener('resize', () => {
    compensateFixedHeader();
});

window.addEventListener('load', () => {
    smoothLoad();
    compensateFixedHeader();
});

// Functions
function compensateFixedHeader() {
    if (!header) {
        return;
    }
    pageContent
        ? (pageContent.style.paddingTop = getComputedStyle(header).height)
        : (document.body.style.paddingTop = getComputedStyle(header).height);
}

function headerWhite() {
    if (!header.dataset.transparentStart || window.innerWidth < desktopRes) {
        return;
    }
    window.scrollY > 10 ? header.classList.add('header--white') : header.classList.remove('header--white');
}

function smoothLoad() {
    document.body.classList.add('loaded');
}

function initReviews() {
    const starsList = document.querySelectorAll('.rating__star-wrapper');
    const defaultTitle = document.querySelector('.rating__title');
    const defaultTitleText = defaultTitle.innerText;

    starsList.forEach(function (starHovered) {
        starHovered.addEventListener('mouseover', function () {
            let title = this.getAttribute('data-title');
            defaultTitle.innerHTML = defaultTitleText + ': <span class="rating__title--green">' + title + '</span>';
        });
        starHovered.addEventListener('mouseout', function () {
            defaultTitle.innerHTML = defaultTitleText;
        });
    });
}
if (document.querySelector('.rating__title') !== null) {
    initReviews();
}

// cvs swiper
const cvsInit = () => {
    const cvsSection = document.querySelector('.professional-cvs');
    if (cvsSection) {
        const swiperBlocks = cvsSection.querySelectorAll('.professional-cvs__swiper');

        swiperBlocks.forEach((swiperBlock) => {
            const navigation = swiperBlock.parentNode.querySelector('.professional-cvs__navigation');
            const btnPrev = navigation.querySelector('.professional-cvs__btn--prev');
            const btnNext = navigation.querySelector('.professional-cvs__btn--next');

            const swiper = new Swiper(swiperBlock, {
                autoHeight: true,
                loop: true,
                speed: 700,
                spaceBetween: 15,
                navigation: {
                    prevEl: btnPrev,
                    nextEl: btnNext,
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                    },
                    575: {
                        slidesPerView: 2,
                    },
                    991: {
                        slidesPerView: 3,
                    },
                },
            });

            swiper.slides.length <= swiper.passedParams.slidesPerView &&
                navigation.classList.add('professional-cvs__navigation--disabled');
        });
    }
};
cvsInit();

// profession swiper
const professionSwiperInit = () => {
    const professionSwipers = document.querySelectorAll('.profession-swiper');
    if (professionSwipers.length) {
        professionSwipers.forEach((swiper) => {
            const navigation = swiper.querySelector('.profession-swiper__navigation');
            const pagination = navigation.querySelector('.profession-swiper__pagination');
            const btnPrev = navigation.querySelector('.profession-swiper__btn--prev');
            const btnNext = navigation.querySelector('.profession-swiper__btn--next');

            new Swiper(swiper, {
                autoHeight: true,
                speed: 700,
                spaceBetween: 20,
                pagination: {
                    el: pagination,
                    clickable: true,
                },
                navigation: {
                    prevEl: btnPrev,
                    nextEl: btnNext,
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                    },
                    575: {
                        slidesPerView: 2,
                    },
                    991: {
                        slidesPerView: 3,
                    },
                },
            });
        });
    }
};
professionSwiperInit();
